export const products = [
  {
    id: 'equivalent-parfum-recherche',
    name: 'L\'équivalent de mon parfum',
    category: 'Parfums',
    price: 0,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/d28da55b258bf74d6f028728e80a25c9.png',
    description: 'Vous cherchez l\'équivalent d\'un parfum spécifique ? Contactez-nous via WhatsApp en remplissant le formulaire sous la catégorie "Parfums" qui fournira le nom de votre parfum et nous vous aiderons à trouver son équivalent dans notre collection'
  },
  {
    id: 'parfum-premium-100ml',
    name: 'Parfum Chogan Premium',
    category: 'Parfums',
    price: 35.00,
    image: 'https://elrlkugihftrpatzyosz.supabase.co/storage/v1/object/public/Pics/1.jpeg',
    description: 'Parfum premium de luxe, fragrance exclusive et raffinée',
    variants: ['100ml', '50ml', '35ml']
  },
  {
    id: 'parfum-chogan-25',
    name: 'Parfum Chogan Élégance',
    category: 'Parfums',
    price: 25.00,
    image: 'https://elrlkugihftrpatzyosz.supabase.co/storage/v1/object/public/Pics/2.jpeg',
    description: 'Parfum Chogan élégant, fragrance raffinée et délicate',
    variants: ['100ml', '50ml', '35ml']
  },
  {
    id: 'parfum-chogan-prestige',
    name: 'Parfum Chogan Prestige',
    category: 'Parfums',
    price: 35.00,
    image: 'https://elrlkugihftrpatzyosz.supabase.co/storage/v1/object/public/Pics/3.jpeg',
    description: 'Parfum Chogan prestige, fragrance sophistiquée et intense',
    variants: ['100ml', '50ml', '35ml']
  },
  {
    id: 'parfum-chogan-essence',
    name: 'Parfum Chogan Essence',
    category: 'Parfums',
    price: 25.00,
    image: 'https://elrlkugihftrpatzyosz.supabase.co/storage/v1/object/public/Pics/4.jpeg',
    description: 'Parfum Chogan essence, fragrance subtile et envoûtante',
    variants: ['100ml', '50ml', '35ml']
  },
  {
    id: 'parfum-femme-essence-olfazeta',
    name: 'Parfum Femme Essence Olfazeta 30%',
    category: 'Parfums',
    price: 18.00,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/e5687e53c6b0f2333f54f0487bf1ddaf.jpeg',
    description: 'Extrait de parfum Olfazeta pour femme, concentration 30%, fragrance élégante et raffinée dans un flacon de 30ml',
    variants: ['30ml']
  },
  {
    id: 'parfum-homme-essence-olfazeta',
    name: 'Parfum Homme Essence Olfazeta 30%',
    category: 'Parfums',
    price: 18.00,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/89f906b0623846525a89c64a66323a4d.jpeg',
    description: 'Extrait de parfum Olfazeta pour homme, concentration 30%, fragrance masculine et élégante dans un flacon de 30ml',
    variants: ['30ml']
  },
  {
    id: 'etui-parfum-poche-modern',
    name: 'Étui à parfum de poche Modern',
    category: 'Parfums',
    price: 13.00,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/38a1c9b4f638ba5a7cd585af869d4830.jpeg',
    description: 'Étui à parfum de poche Olfazeta Modern, design élégant et pratique pour transporter votre fragrance préférée partout avec vous'
  },
  {
    id: 'etui-parfum-poche-monogram-rope',
    name: 'Étui à parfum de poche Monogram Rope - Rouge et vert',
    category: 'Parfums',
    price: 15.00,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/c41699d303f6f186846864cdec7b8202.jpeg',
    description: 'Étui à parfum de poche Olfazeta Monogram Rope, design rouge et vert élégant et pratique pour transporter votre fragrance préférée partout avec vous'
  },
  {
    id: 'recharge-parfum-homme-essence-30',
    name: 'Recharge parfum homme - 30% essence',
    category: 'Parfums',
    price: 11.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/2d80f01d8371365b0225125715a6f965.jpeg',
    description: 'Recharge de parfum Olfazeta pour homme, concentration 30% essence, flacon de 15ml idéal pour recharger votre étui à parfum de poche'
  },
  {
    id: 'recharge-parfum-femme-essence-30',
    name: 'Recharge parfum femme - 30% essence',
    category: 'Parfums',
    price: 11.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/384734dc237cd6c3ba6530792c1788eb.jpeg',
    description: 'Recharge de parfum Olfazeta pour femme, concentration 30% essence, flacon de 15ml idéal pour recharger votre étui à parfum de poche'
  },
  {
    id: 'savon-noir-nigeria',
    name: 'Savon Noir du Nigeria',
    category: 'Corps et Hygiène',
    price: 5.00,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/edc080b67d0b5b119b219d087a8a8e16.jpeg',
    description: 'Le savon noir du Nigéria est un soin naturel ancestral qui nettoie en profondeur, purifie les imperfections et illumine le teint grâce à ses propriétés exfoliantes et apaisantes - 400g'
  },
  {
    id: 'savon-noir-maroc',
    name: 'Savon noir du Maroc',
    category: 'Corps et Hygiène',
    price: 9.00,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/7649bf31a26f64f27bf68d8cd05cc1c0.jpeg',
    description: 'Véritable secret de beauté du rituel du hammam, le savon noir du Maroc purifie la peau en profondeur et l\'exfolie tout en douceur pour la laisser incroyablement soyeuse, régénérée et éclatante - 250g'
  },
  {
    id: 'poudre-nila-sahara',
    name: 'Poudre de Nila',
    category: 'Corps et Hygiène',
    price: 10.00,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/4c7fb3c00a845f68cbf829f2ade8bb2b.jpeg',
    description: 'La poudre de Nila, ce précieux secret de beauté du Sahara, est réputée pour ses vertus éclaircissantes et unifiantes qui estompent les taches brunes et les zones sombres (coudes, genoux). Elle purifie la peau en profondeur tout en lui redonnant un éclat naturel et une douceur remarquable dès la première utilisation - 100g'
  },
  {
    id: 'elixir-acides-fruits',
    name: 'Élixir aux acides de fruits',
    category: 'Corps et Hygiène',
    price: 10.00,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/dbf9e875404f69efd756f94af020596b.jpeg',
    description: 'Élixir aux Acides de Fruits - Huile corporelle formulée à partir de pulpes de carotte, papaye, mangue et orange macérées dans une huile végétale. Naturellement riches en acides de fruits, ces actifs contribuent à illuminer la peau, à améliorer son aspect et à lui apporter douceur et confort. Convient à tous les types de peau. Usage quotidien. Appliquer sur peau propre et légèrement humide. Masser délicatement jusqu\'à absorption complète. Usage externe uniquement - 200ml'
  },
  {
    id: 'glow-body-oil',
    name: 'Glow Body Oil',
    category: 'Corps et Hygiène',
    price: 44.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/66e75e53a95ffd4dae9d5c5694ed1b0a.jpeg',
    description: 'Glow Body Oil AURODHEA 100 ml - Enrichi en huile d\'Amande douce et huile de noix de Coco. Illumine et sublime la peau pour un éclat doré et une hydratation intense'
  },
  {
    id: 'nettoyant-intime-aloe-vera-bio',
    name: 'Nettoyant Intime à l\'Aloe Vera Bio',
    category: 'Corps et Hygiène',
    price: 3.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/c49c7723618e7e8749dd12f7f38bd2fe.jpeg',
    description: 'Nettoyant Intime AURODHEA 50 ml - Enrichi en Mauve et Camomille. Formule douce et apaisante pour l\'hygiène intime quotidienne, respecte l\'équilibre naturel de la peau',
    variants: ['50ml']
  },
  {
    id: 'creme-pieds-calendula',
    name: 'Crème pieds au Calendula',
    category: 'Corps et Hygiène',
    price: 10.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/54133839bbf72e603202095e58b4df8d.jpeg',
    description: 'Crème pieds AURODHEA 75 ml - Enrichie en huile d\'Argan, Sauge et Vitamine E. Formule apaisante et hydratante pour des pieds doux et revitalisés'
  },
  {
    id: 'deocream-bave-escargot',
    name: 'Déo-crème à la Bave d\'Escargot',
    category: 'Corps et Hygiène',
    price: 10.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/b04aa0b6ae14416b5f8e7fff9f528d64.jpeg',
    description: 'Déo-crème AURODHEA 50 ml - Naturel et hypoallergénique. Enrichi en Vitamine E et extrait de Romarin. Pour les peaux délicates et sensibles, protection longue durée sans aluminium'
  },
  {
    id: 'creme-corps-bave-escargot',
    name: 'Crème corps à la bave d\'Escargot',
    category: 'Corps et Hygiène',
    price: 25.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/33c370a239b767abba43868bca5dadd6.jpeg',
    description: 'Crème corps AURODHEA 150 ml - Enrichie en huile d\'Argan, huile d\'Amande douce et huile de Jojoba. Hydrate intensément et régénère la peau pour un corps doux et soyeux'
  },
  {
    id: 'dentifrice-sensitive-aloe-vera',
    name: 'Dentifrice Sensitive à l\'Aloe Vera',
    category: 'Corps et Hygiène',
    price: 17.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/b9b62145580c999dc835ba96dd0cd920.jpeg',
    description: 'Dentifrice Sensitive AURODHEA 150 ml - Enrichi en extraits de Souci, Camomille, Citron et Aloe Vera. Formule douce spécialement conçue pour les gencives hypersensibles, apaise et protège tout en nettoyant délicatement'
  },
  {
    id: 'dentifrice-blanchissant-aloe-vera',
    name: 'Dentifrice blanchissant à l\'Aloe vera',
    category: 'Corps et Hygiène',
    price: 5.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/4324a686e0b07cf1b5b07a60c22ddfe2.jpeg',
    description: 'Dentifrice blanchissant AURODHEA 30 g - Enrichi en Propolis et Xylitol. Formule blanchissante qui nettoie en profondeur, protège l\'émail et laisse les dents éclatantes de blancheur'
  },
  {
    id: 'masque-visage-neem',
    name: 'Masque visage dermo-purifiant à l\'huile de Neem',
    category: 'Soins du Visage',
    price: 18.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/a0d27ccb7788919bf3da2d3978084c6f.jpeg',
    description: 'Masque visage purifiant enrichi en extrait d\'Ortie et Argile verte, à l\'huile de Neem pour une peau nette et éclatante'
  },
  {
    id: 'gel-visage-purifiant',
    name: 'Gel visage purifiant à l\'Acide salicylique',
    category: 'Soins du Visage',
    price: 25.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/1ee946549fde3ae47feb1139692d9931.jpeg',
    description: 'Gel visage purifiant à l\'Acide salicylique - Pour les peaux impures et à tendance acnéique. Enrichi en extrait de Bardane et Aloe Vera'
  },
  {
    id: 'creme-jour-aloe-vera',
    name: 'Crème de jour visage Aloe Vera',
    category: 'Soins du Visage',
    price: 34.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/41d11be439051d5ebe61ac6e9fc8ad55.jpeg',
    description: 'Crème de jour visage enrichie en huile d\'Argan, Panthénol, Protéines de Soie, huile de Jojoba et Aloe Vera pour une hydratation optimale'
  },
  {
    id: 'eau-micellaire-3-en-1',
    name: 'Eau micellaire 3 en 1',
    category: 'Soins du Visage',
    price: 14.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/e92aced533f0facad34d928f88a1b6fe.jpeg',
    description: 'Eau micellaire 3 en 1 - Enrichi en extrait de Concombre et Glycérine. Démaquille, nettoie et apaise la peau en un seul geste'
  },
  {
    id: 'demaquillant-biphase',
    name: 'Démaquillant Biphasé',
    category: 'Soins du Visage',
    price: 24.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/6dddd452721c28862d2dd69dcd939443.jpeg',
    description: 'Démaquillant Biphasé AURODHEA 200 ml - Enrichi en Propanediol. Idéal pour les yeux sensibles, élimine efficacement le maquillage waterproof'
  },
  {
    id: 'base-teint-lissante',
    name: 'Base de teint lissante',
    category: 'Soins du Visage',
    price: 39.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/5e5bd4026cf4b83c5c2de49871ba96bf.jpeg',
    description: 'Base de teint lissante AURODHEA 15 ml - Enrichie en Squalane Végétal et en huile de Rose Musquée. Lisse et unifie le teint pour un maquillage parfait'
  },
  {
    id: 'creme-nuit-lait-anesse',
    name: 'Crème de nuit visage au Lait d\'ânesse',
    category: 'Soins du Visage',
    price: 59.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/e5b262862333cfe913890e4c9579e0e7.jpeg',
    description: 'Crème de nuit visage AURODHEA 50 ml - Enrichie en huile d\'Amande douce, Protéines de Soie et en Acide hyaluronique. Régénère et nourrit intensément la peau pendant la nuit'
  },
  {
    id: 'creme-visage-argan',
    name: 'Crème visage à l\'huile d\'Argan',
    category: 'Soins du Visage',
    price: 39.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/da639e87de34cd56faf712401bd84d3f.jpeg',
    description: 'Crème visage AURODHEA 50 ml - Enrichie en acide hyaluronique, vitamine E et huile de Jojoba. Action anti-âge intense et réparatrice pour une peau visiblement plus jeune'
  },
  {
    id: 'masque-visage-purifiant-salicylique',
    name: 'Masque visage purifiant à l\'Acide Salycilique',
    category: 'Soins du Visage',
    price: 14.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/06a12f517a4ac8f948d7940229db6022.jpeg',
    description: 'Masque visage purifiant AURODHEA 50 ml - Enrichi en extraits de Sauge, Citron et Hamamélis. Purifie en profondeur et resserre les pores pour une peau nette et éclatante'
  },
  {
    id: 'masque-peel-off-peaux-matures',
    name: 'Masque visage Peel-off pour les peaux matures',
    category: 'Soins du Visage',
    price: 21.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/c99e1f4be35d89085d112882715af311.jpeg',
    description: 'Masque visage Peel-off AURODHEA 75 ml - Avec acide hyaluronique, protéines de soie et avoine. Spécialement conçu pour les peaux matures, revitalise et raffermit la peau'
  },
  {
    id: 'creme-contour-yeux-peptilux',
    name: 'Peptilux - Crème anti-rides pour les yeux à effet « shock action » avec LIPHASYN™',
    category: 'Soins du Visage',
    price: 99.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/5a85a4758f66921e5f93855ed3806212.jpeg',
    description: 'Crème contour des yeux PEPTILUX 20 ml - Avec peptides et Liquid Glass. Formule avec LIPHASYN™, un complexe peptidique avec un effet tenseur immédiat. Réduit visiblement les rides et ridules'
  },
  {
    id: 'nettoyant-dermo-purifiant-anti-acne',
    name: 'Nettoyant dermo-purifiant anti-acné à l\'Acide salicylique',
    category: 'Soins du Visage',
    price: 19.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/271000ac6165f65291b598ffda0d7798.jpeg',
    description: 'Nettoyant dermo-purifiant anti-acné AURODHEA 260 ml - Enrichi en Vitamine E et extrait d\'Ortie et Sauge. Idéal pour les peaux à tendance acnéique, nettoie en profondeur et purifie'
  },
  {
    id: 'masque-visage-regenerant-illuminateur',
    name: 'Masque visage illuminateur et éclaircissant à la bave d\'Escargot et vitamine C - 50 ml',
    category: 'Soins du Visage',
    price: 13.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/b11d3a73200bb3f06741b3eb22269720.jpeg',
    description: 'Masque visage régénérant et illuminateur AURODHEA 50 ml - Enrichi en bave d\'Escargot et vitamine C. Illumine le teint, réduit les taches pigmentaires et régénère la peau en profondeur'
  },
  {
    id: 'creme-contour-yeux-aloe-vera',
    name: 'Crème contour des yeux à l\'Aloe Vera',
    category: 'Soins du Visage',
    price: 26.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/c0b3b6fc698bf7810cc805d2887cb83e.jpeg',
    description: 'Crème contour des yeux AURODHEA 15 ml - Enrichie en Echinacée, protéines de Soie et huile d\'Argan. Hydrate, apaise et réduit les signes de fatigue pour un regard frais et reposé'
  },
  {
    id: 'creme-contour-yeux-bave-escargot',
    name: 'Crème contour des yeux à la bave d\'Escargot - 15 ml',
    category: 'Soins du Visage',
    price: 29.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/6fe7ada8b853699165322558b3524fe3.jpeg',
    description: 'Crème contour des yeux AURODHEA 15 ml - Enrichie en bave d\'Escargot, acide hyaluronique et huile de pépins de Raisin, beurre de Cacao et Rose Musquée. Régénère, hydrate et lisse le contour des yeux pour un regard éclatant'
  },
  {
    id: 'serum-gel-tenseur-acide-hyaluronique',
    name: 'Sérum gel tenseur à l\'Acide hyaluronique',
    category: 'Soins du Visage',
    price: 39.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/71fd4622f5927196b6d3652190adbb8f.jpeg',
    description: 'Sérum gel tenseur AURODHEA 50 ml - Enrichi en Collagène, Acmella Oleracea, Centella Asiatica et Kigelia. Effet tenseur immédiat, lisse les rides et raffermit la peau pour un teint visiblement plus jeune'
  },
  {
    id: 'creme-visage-anti-age-bave-escargot',
    name: 'Crème visage anti-âge à la bave d\'escargot',
    category: 'Soins du Visage',
    price: 39.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/535580dbd184abba181f605e126f3f88.jpeg',
    description: 'Crème visage anti-âge AURODHEA 50 ml - Enrichie Acide hyaluronique, Acmella Oleracea, huile d\'Argan et vitamine E. Formule régénérante et anti-âge pour une peau visiblement plus jeune et éclatante'
  },
  {
    id: 'creme-visage-collagene-acide-hyaluronique',
    name: 'Crème visage au Collagène et à l\'Acide hyaluronique',
    category: 'Soins du Visage',
    price: 26.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/948fdbd59dedfd19c827b16b94f673b6.jpeg',
    description: 'Crème visage AURODHEA 50 ml - Enrichie en huile de pépins de raisin, huile d\'argan, huile de karité et vitamine E. Formule repulpante et élastifiante pour une peau ferme et éclatante'
  },
  {
    id: 'masque-visage-anti-age-argan',
    name: 'Masque Visage Anti-Âge à l\'Huile d\'Argan',
    category: 'Soins du Visage',
    price: 19.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/c1fee362b9b2d13c732634610654688c.jpeg',
    description: 'Masque visage anti-âge AURODHEA 50 ml - Enrichi en Huile de Jojoba, Huile de Pépins de Raisin et Beurre de Karité. Formule nourrissante et régénérante pour une peau visiblement plus jeune et éclatante'
  },
  {
    id: 'creme-jour-lait-anesse',
    name: 'Crème de jour au lait d\'Ânesse',
    category: 'Soins du Visage',
    price: 49.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/796d27a9b21b2c6862170acc6fa44257.jpeg',
    description: 'Crème de jour visage AURODHEA 50 ml - Enrichie en Vitamine E, Acide hyaluronique, extraits de Pomme et Concombre. Hydrate intensément et protège la peau tout au long de la journée pour un teint éclatant et revitalisé'
  },
  {
    id: 'creme-visage-neem',
    name: 'Crème visage à l\'huile de Neem - 50 ml',
    category: 'Soins du Visage',
    price: 34.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/2a15accc398602dc35daae99c48b5cdb.jpeg',
    description: 'Crème visage AURODHEA 50 ml - Enrichie en Aloe Vera, Acide hyaluronique, Bardane et Huile d\'Amande douce. Purifie, hydrate et apaise la peau pour un teint éclatant et sain'
  },
  {
    id: 'gel-nettoyant-visage-vegan-baobab',
    name: 'Gel nettoyant visage Végan à l\'huile de Baobab',
    category: 'Soins du Visage',
    price: 24.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/9baf9d4278512a38ec313335fcf45900.jpeg',
    description: 'Gel nettoyant visage Végan AURODHEA 260 ml - Enrichi en Aloe Vera, Mauve et Camomille. Nettoie en douceur, apaise et hydrate la peau pour un teint frais et éclatant'
  },
  {
    id: 'gel-exfoliant-visage-avoine-camomille',
    name: 'Gel exfoliant visage',
    category: 'Soins du Visage',
    price: 21.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/bddc3d63fac830bcc798719473e13839.jpeg',
    description: 'Gel exfoliant visage AURODHEA 50 ml - Enrichi en Avoine, Camomille, Mauve et Calendula. Exfolie en douceur, élimine les cellules mortes et révèle une peau douce et éclatante'
  },
  {
    id: 'masque-peel-off-aloe-vera-peaux-mixtes',
    name: 'Masque visage Peel-off à l\'Aloe vera - Pour les peaux mixtes et grasses',
    category: 'Soins du Visage',
    price: 18.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/02de74c51366f2bd2b92c8cb7b75f67f.jpeg',
    description: 'Masque visage Peel-off AURODHEA 75 ml - Enrichi en Réglisse, Enanthia chlorantha et Romarin. Spécialement formulé pour les peaux mixtes et grasses, purifie, matifie et resserre les pores pour une peau nette et éclatante'
  },
  {
    id: 'gel-nettoyant-visage-bave-escargot',
    name: 'Gel nettoyant visage à la Bave d\'Escargot',
    category: 'Soins du Visage',
    price: 24.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/290ef6af984490672993904324e793fd.jpeg',
    description: 'Gel nettoyant visage AURODHEA 260 ml - Enrichi en Aloe vera et extraits d\'Avoine et Camomille. Nettoie en douceur, régénère et apaise la peau pour un teint frais et éclatant'
  },
  {
    id: 'lotion-tonique-peaux-impures-acneiques',
    name: 'Lotion tonique pour les peaux impures et acnéiques - 150 ml',
    category: 'Soins du Visage',
    price: 18.00,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/8805a1b08d4a3dee3b4f7288dfdc4e6a.jpeg',
    description: 'Lotion tonique AURODHEA 150 ml - Enrichie en extraits de Bardane, de Sauge et d\'Ortie. Spécialement formulée pour les peaux impures et acnéiques, purifie, tonifie et équilibre la peau pour un teint net et éclatant'
  },
  {
    id: 'lait-nettoyant-visage-aloe-vera',
    name: 'Lait nettoyant',
    category: 'Soins du Visage',
    price: 15.50,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/a0a9dbc40ea659491b363c9ada1a5959.jpeg',
    description: 'Lait nettoyant AURODHEA 150 ml - Enrichi en Aloe vera, Calendula, Mauve, Hamamélis et Camomille. Démaquille et nettoie en douceur tout en apaisant et hydratant la peau pour un teint frais et éclatant'
  },
  {
    id: 'lotion-tonique-visage-peaux-delicates-sensibles',
    name: 'Lotion tonique visage pour les peaux délicates et sensibles - 150 ml',
    category: 'Soins du Visage',
    price: 15.50,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/e78bcd5b5fcfa766859dca255ade1b60.jpeg',
    description: 'Lotion tonique visage AURODHEA 150 ml - Enrichi en Camomille, Mauve, Avoine et Calendula. Spécialement formulée pour les peaux délicates et sensibles, apaise, tonifie et rafraîchit la peau pour un teint éclatant et confortable'
  },
  {
    id: 'serum-capillaire-reparateur-argan',
    name: 'Sérum Capillaire Réparateur à l\'Huile d\'Argan',
    category: 'Soins Capillaires',
    price: 36.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/5380012fcd115a44e8c9e215aeb9b90e.jpeg',
    description: 'Sérum capillaire réparateur AURODHEA 30 ml - Enrichi en Huiles de Lin et de Macadamia et en Vitamine E. Démêle et sublime la brillance des cheveux pour une chevelure éclatante et soyeuse'
  },
  {
    id: 'lotion-capillaire-rafraichissante-menthol-camphre',
    name: 'Lotion capillaire rafraîchissante au Menthol et au Camphre',
    category: 'Soins Capillaires',
    price: 24.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/309936799123f3025dc5fb1b5d58a4f2.jpeg',
    description: 'Lotion capillaire rafraîchissante AURODHEA 100 ml - Enrichi en huile essentielle d\'Eucalyptus. Revitalise, stimule la circulation sanguine et apporte une sensation de fraîcheur intense au cuir chevelu'
  },
  {
    id: 'light-drops-floral-sweetness-serum-cheveux',
    name: 'LIGHT DROPS « Floral Sweetness » - Sérum cheveux',
    category: 'Soins Capillaires',
    price: 29.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/29a8fd692ddd040a1a5806bcb90fc071.jpeg',
    description: 'Sérum cheveux LIGHT DROPS AURODHEA 50 ml - Avec mélange breveté NUTRIGLOW™. Nourrit, protège et sublime la brillance des cheveux pour une chevelure éclatante et soyeuse'
  },
  {
    id: 'light-drops-chocolate-obsession-serum-cheveux',
    name: 'LIGHT DROPS « Chocolate Obsession» - Sérum cheveux',
    category: 'Soins Capillaires',
    price: 29.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/23b8c0f7a55c3c4fb7f40b9280a816e9.jpeg',
    description: 'Sérum cheveux LIGHT DROPS AURODHEA 50 ml - Avec mélange breveté NUTRIGLOW™ et Cristaux Liquides. Nourrit intensément, répare et sublime la brillance des cheveux pour une chevelure éclatante et soyeuse'
  },
  {
    id: 'masque-capillaire-nourrissant-argan',
    name: 'Masque capillaire nourrissant à l\'huile d\'Argan',
    category: 'Soins Capillaires',
    price: 16.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/8af9df6a075f50841b9aa63d2bc086bb.jpeg',
    description: 'Masque capillaire nourrissant AURODHEA 150 ml - Enrichi en huile d\'Amande douce, huile d\'Avocat, Panthénol et Vitamine E. Nourrit et donne de la brillance aux cheveux pour une chevelure éclatante et soyeuse'
  },
  {
    id: 'masque-capillaire-demelant-argan',
    name: 'Masque capillaire démêlant à l\'huile d\'argan',
    category: 'Soins Capillaires',
    price: 29.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/292dca2a3df614054728e50fc74df070.jpeg',
    description: 'Masque capillaire démêlant AURODHEA 500 ml - Enrichi en Kératine et en protéines de Soie. Démêle instantanément, répare et nourrit les cheveux pour une chevelure soyeuse et éclatante'
  },
  {
    id: 'masque-cheveux-aloe-vera',
    name: 'Masque cheveux à l\'Aloe Vera',
    category: 'Soins Capillaires',
    price: 9.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/550ac4db0b97f4df8e526cb3405d0a7e.jpeg',
    description: 'Masque cheveux AURODHEA 150 ml - Enrichi en huiles d\'Avocat, de Macadamia et de Lin. Hydrate intensément et nourrit les cheveux pour une chevelure douce, brillante et revitalisée'
  },
  {
    id: 'creme-anti-taches-coloration',
    name: 'Crème anti-taches de coloration',
    category: 'Soins Capillaires',
    price: 19.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/77a8185dccb88652d8bebdf1c5f5a9a9.jpeg',
    description: 'Crème anti-taches de coloration AURODHEA 100 ml - Enrichie en huile de Lin. Protège la peau contre les taches de coloration et facilite le nettoyage après traitement chimique'
  },
  {
    id: 'apres-shampoing-argan',
    name: 'Après-shampoing à l\'huile d\'Argan',
    category: 'Soins Capillaires',
    price: 17.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/b736dadda6611e5aab81ba6d587cef0e.jpeg',
    description: 'Après-shampoing AURODHEA 250 ml - Enrichi en huile de Pépins de Raisin, huile de Tournesol et Vitamine E. Nourrit, démêle et apporte brillance et douceur aux cheveux pour une chevelure soyeuse et éclatante'
  },
  {
    id: 'masque-capillaire-bave-escargot',
    name: 'Masque capillaire à la bave d\'Escargot',
    category: 'Soins Capillaires',
    price: 12.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/bdb10dd1859cc329a7aa6a8890f84aa9.jpeg',
    description: 'Masque capillaire AURODHEA 150 ml - Enrichi en huile de Coton, huile d\'Avocat, beurre de Karité et bave d\'Escargot. Restructure et sublime la brillance des cheveux secs et cassants pour une chevelure douce, soyeuse et revitalisée'
  },
  {
    id: 'shampoing-huile-neem',
    name: 'Shampoing à l\'huile de Neem',
    category: 'Soins Capillaires',
    price: 19.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/4df80688979c8c0f68540d06c77a8f0b.jpeg',
    description: 'Shampoing AURODHEA 250 ml - Enrichi en Ortie et huile de Neem. Équilibre la production de sébum, renforce et volumise les cheveux pour une chevelure saine et éclatante'
  },
  {
    id: 'shampoing-lait-anesse',
    name: 'Shampoing au lait d\'ânesse',
    category: 'Soins Capillaires',
    price: 19.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/11a6b8ab939efc106b92dabf4e6a932f.jpeg',
    description: 'Shampoing AURODHEA 250 ml - Avec vitamine E, extraits de camélia et de camomille, huiles de karité et d\'amande, Panthénol et lait d\'ânesse. Hydratant et doux, idéal pour les cheveux secs et cassants'
  },
  {
    id: 'apres-shampoing-argan-50ml',
    name: 'Après-shampoing à l\'huile d\'Argan',
    category: 'Soins Capillaires',
    price: 3.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/acc6d73a5321a5f1c6c73af307122b91.jpeg',
    description: 'Après-shampoing AURODHEA 50 ml - Enrichi en huile de Pépins de Raisin, huile de Tournesol et Vitamine E. Nourrit, démêle et apporte brillance et douceur aux cheveux pour une chevelure soyeuse et éclatante'
  },
  {
    id: 'shampoing-restructurant-argan',
    name: 'Shampoing restructurant à l\'huile d\'Argan',
    category: 'Soins Capillaires',
    price: 16.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/6514bdc00effd6ef6d13e9775761a530.jpeg',
    description: 'Shampoing restructurant AURODHEA 250 ml - Enrichi en Aloe Vera et Protéines de Soie. Restructure, nourrit et apporte brillance aux cheveux pour une chevelure soyeuse et revitalisée'
  },
  {
    id: 'shampoing-restructurant-argan-50ml',
    name: 'Shampoing restructurant à l\'huile d\'Argan',
    category: 'Soins Capillaires',
    price: 4.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/c41798810d0bf85b944ddcfa0ab3c279.jpeg',
    description: 'Shampoing restructurant AURODHEA 50 ml - Enrichi en Aloe Vera et Protéines de Soie. Restructure, nourrit et apporte brillance aux cheveux pour une chevelure soyeuse et revitalisée'
  },
  {
    id: 'apres-shampoing-bave-escargot',
    name: 'Après-shampoing à la Bave d\'escargot',
    category: 'Soins Capillaires',
    price: 15.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/8c88387ce9622ad6fe8256e6fac1ae7f.jpeg',
    description: 'Après-shampoing AURODHEA 250 ml | Enrichi en huile d\'Amande douce, huile d\'Argan, huile de noix de Coco et Vitamine E'
  },
  {
    id: 'masque-capillaire-spray-bave-escargot',
    name: 'Masque capillaire en spray à la bave d\'Escargot',
    category: 'Soins Capillaires',
    price: 29.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/2339a8459033caad3b51385cfa755c3d.jpeg',
    description: 'Masque capillaire en spray AURODHEA 150 ml - Enrichi en huiles de Karité, Argan, son de Riz, Protéines de la Soie et Panthénol. Formule sans rinçage qui nourrit, répare et protège les cheveux pour une chevelure soyeuse et éclatante'
  },
  {
    id: 'shampoing-lavages-frequents-aloe-vera-50ml',
    name: 'Shampoing lavages fréquents à l\'Aloe vera',
    category: 'Soins Capillaires',
    price: 3.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/63b01e91b91cc9f11baefb5c68c8f15e.jpeg',
    description: 'Shampoing lavages fréquents AURODHEA 50 ml - Enrichi en Panthénol, Protéines de Blé et Extrait de Passiflore. Extra doux pour un usage quotidien, nettoie en douceur et protège les cheveux'
  },
  {
    id: 'brume-cheveux-parfum-42',
    name: 'Brume cheveux - Parfum 42 - 30 ml',
    category: 'Soins Capillaires',
    price: 9.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/0fcefe29949a202b39bd21909ace2db6.jpeg',
    description: 'Brume cheveux AURODHEA 30 ml - Enrichi en vitamine E, en protéines de Soie et en Ginkgo Biloba. Parfume délicatement les cheveux tout en les nourrissant et les protégeant pour une chevelure éclatante et soyeuse'
  },
  {
    id: 'shampoing-anti-chute-cafeine',
    name: 'Shampoing anti-chute',
    category: 'Soins Capillaires',
    price: 19.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/b3635f5ceee7e49f4e2d58c0fc078dab.jpeg',
    description: 'Shampoing anti-chute AURODHEA 250 ml - Enrichi en Caféine, Serenoa, Ginkgo Biloba, Aloe Vera et Horstail. Spécialement formulé pour les cheveux faibles et cassants, stimule la croissance et renforce les cheveux pour une chevelure dense et revitalisée'
  },
  {
    id: 'shampoing-lavages-frequents-aloe-vera-250ml',
    name: 'Shampoing lavages fréquents à l\'Aloe vera',
    category: 'Soins Capillaires',
    price: 10.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/6e37931789574a51d1673d287486da7e.jpeg',
    description: 'Shampoing lavages fréquents CHOGAN 250 ml - Enrichi en Charbon actif. Purifie, équilibre et nettoie en profondeur le cuir chevelu et les cheveux pour une chevelure saine et revitalisée'
  },
  {
    id: 'shampoing-bio-poux-lentes',
    name: 'Shampoing bio contre les poux et les lentes - 200 ml',
    category: 'Soins Capillaires',
    price: 21.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/7d59d7a6ea38510098aad7399a7b394f.jpeg',
    description: 'Shampoing bio AURODHEA 200 ml - Enrichi en Aloe Vera et huile de Neem. Formule naturelle et efficace pour éliminer les poux et les lentes tout en respectant le cuir chevelu. Idéal pour toute la famille'
  },
  {
    id: 'masque-capillaire-demelant-argan-30ml',
    name: 'Masque capillaire démêlant à l\'huile d\'Argan - format voyage',
    category: 'Soins Capillaires',
    price: 3.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/1ffd6b67d9bc9ca828edf7cff1bf840e.jpeg',
    description: 'Masque capillaire démêlant AURODHEA 30 ml - Enrichi en Kératine et en protéines de Soie. Démêle instantanément, répare et nourrit les cheveux pour une chevelure soyeuse et éclatante'
  },
  {
    id: 'shampoing-bave-escargot',
    name: 'Shampooing à la bave d\'Escargot',
    category: 'Soins Capillaires',
    price: 13.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/841fdeac4d924567b321a7de8856dd49.jpeg',
    description: 'Shampooing AURODHEA 250 ml | Enrichi en extrait d\'Avoine, Panthénol et protéines de Soie'
  },
  {
    id: 'shampoing-antipelliculaire-acide-salicylique',
    name: 'Shampoing antipelliculaire à l\'acide salicylique',
    category: 'Soins Capillaires',
    price: 12.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/6eec321727bb91e72f3eec5b4349f0e0.jpeg',
    description: 'Shampoing antipelliculaire AURODHEA 250 ml - Enrichi en Propolis, Panthénol, Menthol et protéines de Blé. Élimine efficacement les pellicules, apaise le cuir chevelu et laisse les cheveux propres et revitalisés'
  },
  {
    id: 'traitement-anti-chute-intensif',
    name: 'Ampoules anti-chute cheveux - Soin intensif',
    category: 'Soins Capillaires',
    price: 48.00,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/88e976b54cf04d1131f5ffdd9ff6a6a9.jpeg',
    description: 'Traitement anti-chute intensif AURODHEA - 10 ampoules de 3 ml chacune. Enrichi en Sphingony, Menthol et Kératine. Formule intensive pour stimuler la croissance capillaire et renforcer les cheveux affaiblis'
  },
  {
    id: 'nettoyant-intime-aloe-vera-bio-260ml',
    name: 'Nettoyant Intime à l\'Aloe Vera Bio',
    category: 'Corps et Hygiène',
    price: 7.90,
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/c49c7723618e7e8749dd12f7f38bd2fe.jpeg',
    description: 'Nettoyant Intime AURODHEA 260 ml - Enrichi en Mauve et Camomille. Formule douce et apaisante pour l\'hygiène intime quotidienne, respecte l\'équilibre naturel de la peau',
    variants: ['260ml']
  }
];
